module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-400.7c9fc9b7.eot";